module.exports = __webpack_public_path__ + "img/Group 20.3b2304b3.png";